import { render, staticRenderFns } from "./EditFiltersView.vue?vue&type=template&id=59e67872&"
import script from "./EditFiltersView.vue?vue&type=script&lang=js&"
export * from "./EditFiltersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports